<template>
  <div>
    <error-on-form-submission v-if="hasErrors"></error-on-form-submission>
    <successful-form-submission
      v-else
      :username="username"
      :password="password"
    ></successful-form-submission>
  </div>
</template>

<script>
import SuccessfulFormSubmission from "@/components/SuccessfulFormSubmission";
import { signupTokenService } from "@/services/signupTokenService";
import ErrorOnFormSubmission from "@/components/ErrorOnFormSubmission";
import jwt_decode from 'jwt-decode'


export default {
  name: "FormSubmitSuccessPage",
  components: {
    SuccessfulFormSubmission,
    ErrorOnFormSubmission,
  },
  data: () => ({
    username: null,
    password: null,
    response: null
  }),
  computed: {
    hasErrors () {
      return this.response === null || !! this.response.errors
    }
  },
  created() {
    // When this component renders we have no use for the signup token anymore if one exists
    signupTokenService(this.$storage, this.$http).clear()
    // This comes as a base 64 encoded query string form the backend api on redirect
    this.response = JSON.parse(atob(this.$route.query.response));

    if (this.hasErrors) {
      return;
    }

    this.username = this.response.user.username;
    this.password = this.response.user.password;
    let token = jwt_decode(this.response.accessToken)
    this.$user.logIn(this.response.accessToken, token.roles[0])
    this.$http.setAuthHeaders();
    let caseId = this.response.case.id
    this.$http.get(`${process.env.VUE_APP_API_URL}/cases/${caseId}`).then((response) => {
      this.$store.commit('addClientCase', response.data);
    })
  }
};
</script>
